import { defineStore } from 'pinia'
import { ref } from 'vue'
import { HomeAPI } from '@/services/home'
import { searchStorage } from '@/utils/storage'

export const useSearchStore = defineStore('search', () => {
  const getCurrentTime = () => {
    const d = new Date()
    const y = d.getFullYear()
    const m = String(d.getMonth() + 1).padStart(2, '0')
    const day = String(d.getDate()).padStart(2, '0')
    return `${y}${m}${day}`
  }
  // 随机列表
  const randomList = ref<any[]>([])
  // 搜索列表
  const searchList = ref<any[]>([])
  // 搜索历史
  const searchHistory = ref<string[]>([])
  // 推荐角色
  const recommendRoles = ref<any[]>([])
  // 热门搜索
  const popularSearch = ref<any[]>([])
  // 加载中
  const loading = ref(false)
  // 是否为空
  const isEmpty = ref(false)
  const setSearchList = async (search: string) => {
    search = search.trim()
    if (!search) {
      isEmpty.value = false
      return
    }
    isEmpty.value = true
    loading.value = true
    const response = await HomeAPI.getRoleList({
      page: 1,
      pageSize: 100,
      keywords: search,
      curDate: Number(getCurrentTime())
    })
    if (response.data && response.data.isRecommend) {
      searchList.value = []
    } else {
      searchList.value = response.data as any || []
    }
    loading.value = false
  }

  const getSearchList = async () => {
    if (searchList.value.length > 0) return
    searchList.value = searchStorage.getSearchList()
    return searchList.value
  }

  const addSearchList = (item: string) => {
    searchList.value.push(item)
  }

  const removeSearchList = () => {
    searchHistory.value =[]
    searchStorage.setSearchList([])
  }
  const removeSearchHistoryItem = (data: string) => {
    searchHistory.value = searchHistory.value.filter((item) => item !== data)
    console.log(searchHistory.value);
    
    // searchStorage.setSearchList([...new Set(searchHistory.value)])
  }

  const setSearchHistory = (search: string) => {
    searchHistory.value = [...new Set([search, ...searchHistory.value])].slice(0, 10)
    searchStorage.setSearchList(searchHistory.value)
  }

  const getSearchHistory = () => {
    searchHistory.value = searchStorage.getSearchList()
    return searchHistory.value
  }

  /**
   * 获取推荐角色
   */
  const getRecommendRoles = async () => {
    // if (recommendRoles.value.length > 0) return
    const response = await HomeAPI.getRecommendRoles({
    })
    recommendRoles.value = response.data.recommendList || []
  }

  const setPopularSearch = async () => {}

  /**
   * 获取热门搜索
   */
  const getPopularSearch = async () => {
    // if (popularSearch.value.length > 0) return
    const response = await HomeAPI.getRoleList({ type: 2 })
    popularSearch.value = response.data as any || []
  }

  const getRandomList = async () => {
    // if (randomList.value.length > 0) return
    const response = await HomeAPI.getRoleList({ type: 3 })
    randomList.value = response.data as any || []
  }

  return {
    searchList,
    randomList,
    setSearchList,
    getSearchList,
    addSearchList,
    removeSearchList,
    searchHistory,
    setSearchHistory,
    getSearchHistory,
    recommendRoles,
    getRecommendRoles,
    popularSearch,
    setPopularSearch,
    getPopularSearch,
    getRandomList,
    removeSearchHistoryItem,
    isEmpty,
    loading
  }
})
